import { render, staticRenderFns } from "./StaffManagement.vue?vue&type=template&id=257e8bde&scoped=true&"
import script from "./StaffManagement.vue?vue&type=script&lang=js&"
export * from "./StaffManagement.vue?vue&type=script&lang=js&"
import style0 from "./StaffManagement.vue?vue&type=style&index=0&id=257e8bde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257e8bde",
  null
  
)

export default component.exports